import { path } from "./path";

import type { IExtendedRouteObject } from "@routes/types.ts";
import { useUIStore } from "@/stores/uiStore";

export const changePasswordRoutes: IExtendedRouteObject[] = [
  {
    route: {
      path: path.changePassword.route,
      lazy: () => import("@pages/panelPages/changePassword/changePassword"),
      loader: ({ request }) => {
        useUIStore
          .getState()
          .setPage(request, "pageTitle.changePassword", [], "index");
        return {};
      },
    },
    permissions: [
      "doctor",
      "patient",
      "local-admin",
      "staff",
      "super-admin",
      "admin",
      "inactive-patient",
      "medical-service-provider-drug",
      "medical-service-provider-lab",
      "medical-service-provider-image",
    ],
  },
];
